"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCollectorService = void 0;
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var ReferenceEvent_service_1 = require("./ReferenceEvent.service");
var EventCollector_1 = __importDefault(require("./core/EventCollector"));
var EventEnums = __importStar(require("./core/eventTypes/EventEnums"));
var detectors_1 = require("./core/utils/detectors");
var events_1 = require("./events");
var model_1 = require("./model");
/**
 * initEventsAPI - create the EventsAPI
 * setEventCollectorContextInfo - set the context infomation.
 * pushEvent - send the event.
 * createEventObject - pass the EventObject model, patching missing fields using context infomation
 * trackReferenceEvent - pass trackEvent function, content ID, and optional properties, adds to localstorage
 * getReferenceEvent - gets reference event from localstorage and resets dataLayer
 * EventsAPI: below is EventsAPI
 * ContentViewV2.pushEvent - send the CONTENT-VIEW-V2 event
 * ContentDownloadV2.pushEvent - send the CONTENT-DOWNLOAD-V2 event
 * ContentViewV2.createEventObject - pass the EventObject model, patching missing fields using context infomation
 * doccenter.createEventContent - pass the EventContent model, patching missing fields using context infomation
 * doccenter.createEventFolder - pass the EventFolder model, patching missing fields using context infomation
 * newscenter.createEventContent - pass the EventContent model, patching missing fields using context infomation
 * library.createEventContent - pass the EventContent model, patching missing fields using context infomation
 * library.createEventFolder - pass the EventData model, patching missing fields using context infomation
 * workspace.createEventContent - pass the EventContent model, patching missing fields using context infomation
 * workspace.createEventFolder - pass the EventFolder model, patching missing fields using context infomation
 */
var EventCollectorService = /** @class */ (function () {
    function EventCollectorService(referenceEventService) {
        var _this = this;
        this.referenceEventService = referenceEventService;
        this.EventCollector = EventCollector_1.default;
        this.events = {
            ContentViewV2: events_1.ContentViewV2,
            ContentDownloadV2: events_1.ContentDownloadV2,
        };
        this.eventsModel = { doccenter: model_1.doccenter, newscenter: model_1.newscenter, library: model_1.library, workspace: model_1.workspace };
        this.EventEnums = EventEnums;
        this.detectOS = detectors_1.detectOS;
        this.detectDevices = detectors_1.detectDevices;
        this.detectBrowser = detectors_1.detectBrowser;
        // init method is called once in full bundle
        // https://github.com/seismic/web-full-bundle-assets/blob/develop/src/%24seismic/api/seismic.init.business.js#L1547
        this.init = function (_a) {
            var _b = _a === void 0 ? {} : _a, hostUrl = _b.hostUrl, onTokenExpired = _b.onTokenExpired;
            if (typeof hostUrl !== 'string' && !hostUrl) {
                throw new Error('hostUrl is required');
            }
            var eventCollector = EventCollector_1.default({
                baseUrlResolver: function () { return hostUrl; },
                onTokenExpired: onTokenExpired,
            });
            _this.registerEventsAPI(eventCollector);
            _this.referenceEventService.addRouteEvents();
        };
        this.registerEventsAPI = function (eventCollector) {
            var api = {};
            Object.keys(_this.events).forEach(function (key) {
                if (key === 'default')
                    return;
                api[key] = _this.events[key](eventCollector);
            });
            Object.keys(_this.eventsModel).forEach(function (key) {
                if (key === 'default')
                    return;
                api[key] = _this.eventsModel[key]();
            });
            Object.assign(_this, api, {
                getEventsQueue: eventCollector.getEventsQueue,
                getErrorReport: eventCollector.getErrorReport,
                getReferenceEvent: _this.referenceEventService.getReferenceEvent,
                setEventCollectorContextInfo: eventCollector.setEventContext,
                pushEvent: eventCollector.pushEvent,
                createEventObject: eventCollector.createEventObject,
                createEventClientDetails: eventCollector.createEventClientDetails,
                createEventIntegratorContext: eventCollector.createEventIntegratorContext,
                setReferenceEvent: _this.referenceEventService.setReferenceEvent,
            });
        };
    }
    EventCollectorService = __decorate([
        CommonService_decorator_1.CommonService('EventCollectorService'),
        __metadata("design:paramtypes", [ReferenceEvent_service_1.ReferenceEventService])
    ], EventCollectorService);
    return EventCollectorService;
}());
exports.EventCollectorService = EventCollectorService;
//# sourceMappingURL=EventCollector.service.js.map